// extracted by mini-css-extract-plugin
module.exports = {"border":"form_border__3TfBU","margin":"form_margin__3Rq0-"};